import Button from '@mui/material/Button'
import { archiveFields } from 'api/field'

export default function ArchiveField(props) {
  const { fieldName, id } = props

  const dispatch = useDispatch()

  const { t } = useTranslation()

  const confirmArchiveField = useCallback(() => {
    dispatch(archiveFields([id]))
  })

  return (
    <>
      <label style={{ color: 'black' }}>
        {t('archive_item', { item: fieldName })}
        <br />
        <br />
        {t('archive_item_warning', { item: t('field') })}
      </label>
      <Button
        color="primary"
        variant="contained"
        onClick={confirmArchiveField}
        sx={{ width: '100%', marginTop: '4px' }}
      >
        {t('archive')}
      </Button>
    </>
  )
}
